<template>
  <van-nav-bar @click-left="ReturnPage()" left-arrow>
    <template #left>
      <van-icon name="arrow-left" color="#000" size="22" />
    </template>
    <template #title>
      <p style="font-size: 14pt">
        {{ ProductDetail.Name }}
      </p>
    </template>
  </van-nav-bar>
  <div style="background-color: #f6f6f6">
    <div
      style="background-color: #fff; width: calc(100% - 8px); margin: 0 auto"
    >
      <van-swipe style="margin: 5px" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            lazy-load
            class="item_picture"
            fit="contain"
            :src="ProductDetail.Images"
          />
        </van-swipe-item>
        <van-swipe-item
          v-for="(item, index) in ProductDetail.Pictures"
          :key="index"
        >
          <van-image
            lazy-load
            class="item_picture"
            fit="contain"
            :src="item.CompleteImageFormet"
          />
        </van-swipe-item>
        <template #indicator="{ active, total }">
          <div class="custom-indicator">{{ active + 1 }}/{{ total }}</div>
        </template>
      </van-swipe>
    </div>

    <div
      style="
        border-radius: 20px 20px 0px 0px;
        background-color: #fff;
        margin: 0 auto;
        width: calc(100% - 10px);
      "
    >
      <div
        style="
          width: calc(100% - 8px);
          margin: 0 auto;

          height: 40px;
          padding: 15px 0px 10px 0px;
          border-radius: 10px;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="line-height: 40px; font-size: 13pt; margin-left: 15px">
            {{ ProductDetail.Name }}
          </div>

          <div style="color: red; padding: 10px">
            <div style="margin-right: 10px; color: red;font-size: 11pt; ">
              <!-- {{
                ProductDetail.IncludeTax
                  ? tools.GetLanguageValue("public.app.价格含税")
                  : tools.GetLanguageValue("public.app.价格不含税")
              }} -->
            </div>

            <div style="font-size: 19pt; ">
              {{ ProductDetail.PriceFormat }}
            </div>
          </div>
        </div>
      </div>
      <!-- 过敏原 -->
      <div
        style="
          background-color: #fff;
          border-radius: 5px;
          width: calc(100% - 8px);
          margin: 0 auto;
          margin-top: 10px;
        "
        v-if="ProductDetail.Allergens.length > 0"
      >
        <div
          style="
            height: 40px;
            border-bottom: 1px solid #e6e6e6;
            line-height: 40px;
            font-size: 18px;
          "
        >
          <span style="margin-left: 12px">
            {{ tools.GetLanguageValue("public.app.过敏原") }}
          </span>
        </div>
        <div
          style="
            width: calc(100% - 20px);
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 auto;
            gap: 15px 5px;
            margin-top: 10px;
          "
        >
          <div
            v-for="item in ProductDetail.Allergens"
            :key="item"
            style="width: 49%; display: flex; align-items: center"
          >
            <van-image
              lazy-load
              class="item_picture"
              fit="contain"
              style="width: 26px"
              :src="item.CompleteImages"
            />

            {{ item.Name }}
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
    <!-- //详细信息 -->
    <div
      style="
        background-color: #fff;
        border-radius: 5px;
        width: calc(100% - 20px);
        margin: 0 auto;
        margin-top: 10px;
        padding: 5px;
      "
    >
      <div
        style="
          height: 40px;
          border-bottom: 1px solid #e6e6e6;
          line-height: 40px;
          font-size: 18px;
        "
      >
        {{ tools.GetLanguageValue("public.app.简介") }}
      </div>
      <div v-html="ProductDetail.Description" style="margin: 15px 4px"></div>
    </div>
    <!-- <div class="item_price_cart">
                <p class="description"> {{ ProductDetail.Description }}
                </p>
                <div class="item_price_cart_bottom">
                </div>
            </div>
        <div class="item_price"    style="color:red;font-size: 22pt;height: 10px; padding: 10px;">
            {{ ProductDetail.PriceFormat }}</div>
        <div class="pricture_name">
            {{ ProductDetail.Name }}
        </div>
        <div  style="width: 100%;margin: 10px;background-color: #fff;border-radius: 8px;" v-html="ProductDetail.Detail.Content">

        </div> -->

    <!-- {{ ProductDetail }} -->
    <br />
    <br />
    <br />
    <br />
  </div>
</template>
<script>
import axios from "../../commons/AxiosMethod.js"
import tabbar from "../../components/tabbars/storeTabbar.vue"
import LanguageSelect from "../../components/LanguageSelect.vue"
import tools from "../../commons/tools.js"
import { Collapse, CollapseItem, Tab, Tabs, showToast, NumberKeyboard } from "vant"

export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      shuoming: "",
      HomeConfigs: {}, // 配置
      IsShowCart: true,
      tools: tools,

      ProductDetail: {
        Detail: {},
        Allergens: []
      } // 预览详细
    }
  },
  name: "App",
  mounted () {
    localStorage.setItem("Cache-TableId", this.$route.query.tableId)
    this.TableId = localStorage.getItem("Cache-TableId")

    this.ProductId = this.$route.query.productId

    this.GetPreviewProductSimple()
  },
  components: {
    tabbar,
    LanguageSelect
  },
  methods: {
    ReturnPage () {
      history.back()
    },
    // 查询预览数据
    GetPreviewProductSimple () {
      axios.apiMethod(
        "/Shopping/Product/GetProduct?Id=" + this.ProductId,
        "get",
        {},
        (result) => {
          this.ProductDetail = result.Data
        }
      )
    },

    GetHomeType () {
      axios.apiMethod(
        "/Store/StoreOrder/GetHomeType",
        "get",
        { tableId: this.TableId },
        (result) => {
          this.HomeConfigs = result.Data
          this.shuoming = this.HomeConfigs.shuoming

          localStorage.setItem(
            "addcartDetailed",
            this.HomeConfigs.addcartDetailed ? "yes" : "no"
          )
          localStorage.setItem(
            "IsShowOverProduct",
            this.HomeConfigs.IsShowOverProduct ? "yes" : "no"
          )
          localStorage.setItem(
            "UseSecurityCode",
            this.HomeConfigs.useSecurityCode ? "yes" : "no"
          )
          localStorage.setItem(
            "IsStoreCategorySidebar",
            this.HomeConfigs.IsStoreCategorySidebar ? "yes" : "no"
          )

          if (!result.Data.openTable) {
            alert("没有开台，请联系服务员!")
            return
          }

          // 是否启用店内定位
          if (result.Data.locationUsing) {
            this.GetDistance()
            return
          }

          this.skipHome = this.HomeConfigs.skipHome
          if (this.skipHome) {
            console.log("店铺设置为跳过首页")
            // 跳过首页
            this.GoOrder()
          }
        }
      )
    },
    Skip (item) {
      var tableId = localStorage.getItem("Cache-TableId")
      this.$router.push({
        path: item,
        query: {
          tableId: tableId
        }
      })
    }
  }
}
</script>
<style>
.shuoming p {
  padding: 0px !important;
  margin: 0px !important;
}
</style>
<style lang="scss" scoped>
.item_price {
  width: 100px;
  line-height: 20px;
  color: #333;
  font-family: "Titillium Web", Arial, sans-serif;
  font-size: 18pt;
  margin-left: 20px;
}

.pricture_name {
  margin-top: 10px;
  margin-left: 40px;
  color: #333;
  font-size: 16pt;
  width: 80%;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
}

.item_content {
  max-width: 95%;
  height: 160px;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);

    border-radius: 5px;
    text-align: center;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 90%;
      max-height: 200px;
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: 95%;

      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 100px;
          line-height: 20px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
          margin-left: 50px;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}
</style>
